// モダンメニューの初期化（PC・モバイル共通）
function initializeModernMegaMenu() {
  // タイムアウト処理を追加
  const timeout = setTimeout(() => {
    console.log('メガメニュー初期化タイムアウト');
    return;
  }, 5000); // 5秒でタイムアウト

  try {
    const items = document.querySelectorAll('.modern-nav__item');
    
    if (items.length === 0) {
      console.log('メガメニュー要素が見つかりません');
      clearTimeout(timeout);
      return;
    }
  
    items.forEach((item, index) => {
      try {
        const button = item.querySelector('.modern-nav__button');
        
        if (!button) {
          console.log(`メニューボタンが見つかりません: インデックス ${index}`);
          return;
        }
  
        button.addEventListener('click', (e) => {
          try {
            e.preventDefault();
            e.stopPropagation();
    
            const isOpen = item.classList.contains('is-open');
    
            // 全て閉じる
            items.forEach(i => {
              i.classList.remove('is-open');
              const btn = i.querySelector('.modern-nav__button');
              btn?.setAttribute('aria-expanded', 'false');
            });
    
            // 現在のメニューを開く
            if (!isOpen) {
              item.classList.add('is-open');
              button.setAttribute('aria-expanded', 'true');
            }
          } catch (error) {
            console.log('メニュークリック処理エラー:', error);
          }
        });
      } catch (error) {
        console.log(`メニュー項目初期化エラー (インデックス ${index}):`, error);
      }
    });
  
    // 外側をクリックしたら全て閉じる
    document.addEventListener('click', (e) => {
      try {
        if (!e.target.closest('.modern-nav')) {
          items.forEach(item => {
            item.classList.remove('is-open');
            const btn = item.querySelector('.modern-nav__button');
            btn?.setAttribute('aria-expanded', 'false');
          });
        }
      } catch (error) {
        console.log('外側クリック処理エラー:', error);
      }
    });

    clearTimeout(timeout);
    console.log('メガメニュー初期化完了');
  } catch (error) {
    clearTimeout(timeout);
    console.log('メガメニュー初期化エラー:', error);
  }
}
  
// ハンバーガーメニュー開閉（SP）
function initializeHamburgerMenu() {
  // タイムアウト処理を追加
  const timeout = setTimeout(() => {
    console.log('ハンバーガーメニュー初期化タイムアウト');
    return;
  }, 5000); // 5秒でタイムアウト

  try {
    const toggleButtons = document.querySelectorAll('.js-menu-toggle');
    const closeButtons = document.querySelectorAll('.js-menu-close');
    const mobileMenu = document.querySelector('.mobile-menu');
    
    if (toggleButtons.length === 0 || !mobileMenu) {
      console.log('ハンバーガーメニュー要素が見つかりません');
      clearTimeout(timeout);
      return;
    }
    
    let isOpen = false;
  
    toggleButtons.forEach((btn, index) => {
      try {
        btn.addEventListener('click', () => {
          try {
            isOpen ? closeMenu() : openMenu();
          } catch (error) {
            console.log('ハンバーガーメニュートグルエラー:', error);
          }
        });
      } catch (error) {
        console.log(`ハンバーガーボタン初期化エラー (インデックス ${index}):`, error);
      }
    });
  
    closeButtons.forEach((btn, index) => {
      try {
        btn.addEventListener('click', () => closeMenu());
      } catch (error) {
        console.log(`クローズボタン初期化エラー (インデックス ${index}):`, error);
      }
    });
  
    function openMenu() {
      try {
        mobileMenu?.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        isOpen = true;
      } catch (error) {
        console.log('メニューオープンエラー:', error);
      }
    }
  
    function closeMenu() {
      try {
        mobileMenu?.classList.remove('is-active');
        document.body.style.overflow = '';
        isOpen = false;
  
        // サブメニューも閉じる
        const items = mobileMenu.querySelectorAll('.modern-nav__item');
        items.forEach(item => {
          item.classList.remove('is-open');
          const btn = item.querySelector('.modern-nav__button');
          btn?.setAttribute('aria-expanded', 'false');
        });
      } catch (error) {
        console.log('メニュークローズエラー:', error);
      }
    }

    clearTimeout(timeout);
    console.log('ハンバーガーメニュー初期化完了');
  } catch (error) {
    clearTimeout(timeout);
    console.log('ハンバーガーメニュー初期化エラー:', error);
  }
}
  
// 重複初期化を防ぐための厳密なチェック
if (!window._modernMegaMenuInitialized) {
  // Instagramインアプリブラウザ対応の遅延初期化
  const isInstagramInApp = /Instagram/.test(navigator.userAgent);
  const initDelay = isInstagramInApp ? 1000 : 0;
  
  // 全体のタイムアウト処理
  const globalTimeout = setTimeout(() => {
    console.log('メガメニュー全体初期化タイムアウト');
    window._modernMegaMenuInitialized = true;
  }, 10000); // 10秒でタイムアウト
  
  setTimeout(() => {
    try {
      document.addEventListener('DOMContentLoaded', () => {
        initializeModernMegaMenu();
        initializeHamburgerMenu();
        clearTimeout(globalTimeout);
        window._modernMegaMenuInitialized = true;
      });
    } catch (error) {
      console.log('メガメニュー全体初期化エラー:', error);
      clearTimeout(globalTimeout);
      window._modernMegaMenuInitialized = true;
    }
  }, initDelay);
}
  